import MenuNames from "../../../constants/Menu/MenuNames.json";
import SubIssueTips from "../../../views/SubIssueTips";
import SubIssueTipsAction from "../../../views/SubIssueTipsAction";

const LogisticsSupportRoutes = [
  {
    menuName: MenuNames.LOGISTICS_SUPPORT_DASHBOARD,
    path: "/sub-issue-types/:id/tips",
    component: SubIssueTips,
    exact: true,
  },
  {
    menuName: MenuNames.LOGISTICS_SUPPORT_DASHBOARD,
    path: "/sub-issue-types/:id/tips/create",
    component: SubIssueTipsAction,
    exact: true,
  },
  {
    menuName: MenuNames.LOGISTICS_SUPPORT_DASHBOARD,
    path: "/sub-issue-types/:id/tips/:tipId/:action",
    component: SubIssueTipsAction,
    exact: true,
  },
];

export default LogisticsSupportRoutes;